import { LevelProps } from './tokens'
import { DNA } from '../visual-language'
import { calcLineHeight } from '../utils'

export const detailStyles = ({ level = 'medium' }: DetailStylesProps = {}) => ({
  ...levelStyles[level],
})

const levelStyles = {
  xlarge: {
    fontSize: DNA.tokens.dimension.font[200],
    lineHeight: calcLineHeight({
      fontSize: DNA.tokens.dimension.font[200],
      lineHeight: 1.5,
    }),
  },
  large: {
    fontSize: DNA.tokens.dimension.font[100],
    lineHeight: calcLineHeight({
      fontSize: DNA.tokens.dimension.font[100],
      lineHeight: 1.5,
    }),
  },
  medium: {
    fontSize: DNA.tokens.dimension.font[75],
    lineHeight: calcLineHeight({
      fontSize: DNA.tokens.dimension.font[75],
      lineHeight: 1.5,
    }),
  },
  small: {
    fontSize: DNA.tokens.dimension.font[50],
    lineHeight: calcLineHeight({
      fontSize: DNA.tokens.dimension.font[50],
      lineHeight: 1.5,
    }),
  },
  xsmall: {
    fontSize: DNA.tokens.dimension.font[25],
    lineHeight: calcLineHeight({
      fontSize: DNA.tokens.dimension.font[25],
      lineHeight: 1.5,
    }),
  },
}

export interface DetailStylesProps extends Partial<LevelProps> {}
